<template>
         <div class="peoplemap-part"> 
            <div id="viewer" class="viewer" style="width: 100vw; height: 100vh;"></div>
            <div id="container"></div>
   
        </div>

</template>

<script>



import { Viewer } from '@photo-sphere-viewer/core';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import * as PANOLENS from 'panolens'

export default {
    name: 'App',
    data() {
        return {

    
        };
    },
    methods: {
      
     

    },
    mounted() {
   

   
             const viewer = new Viewer({
                container: document.querySelector('#viewer'),
                panorama: 'images/location4/4-3-7.jpg',
                defaultPitch: 0,
                defaultYaw: 0,
                defaultZoomLvl:0,
                navbar: [
                ],
                plugins: [

                    [MarkersPlugin, {
                    // list of markers
                        markers: [
                            {
                                id: 'location0436',
                                position: { yaw: 3, pitch: 0 },
                                html: '<div class="level2-btn"><div class="btn-title">'+this.data04[10].name+'</div></div>',
                                scale: [1, 1],
                            },
                            {
                                id: 'inf',
                                position: { yaw: 0.5, pitch: 0.3 },
                                html: '<div class="infbtns"><div class="btn-title">'+this.data04[11].name+'-'+this.datatext[0].inftext+'</div></div>',
                                scale: [1, 1],
                            },
                            {
                                id: 'location0611',
                                position: {
                                    "yaw": -1.3,
                                    "pitch": 0.6
                                },
                                html: '<div class="level1-btn"><div class="btn-title">'+this.data06[1].name+'</div></div>',
                                scale: [1, 1],
                                hoverScale: 1.1,
                            },                            
                            {
                                id: 'location0441',
                                position: {
                                    "yaw": -1.3,
                                    "pitch": 0.8
                                },
                                html: '<div class="level1-btn"><div class="btn-title">'+this.data04[12].name+'</div></div>',
                                scale: [0.8, 0.8],
                                hoverScale: 1.1,
                            },
                             {
                                id: 'location0421',
                                position: {
                                    yaw: 1, pitch: 0.5
                                },
                                html: '<div class="level1-btn"><div class="btn-title">'+this.data04[2].name+'</div></div>',
                                scale: [1, 1],
                                hoverScale: 1.1,
                            },                                 
                             {
                                id: 'location0451',
                                position: {
                                    yaw: 1.8, pitch: 0.5
                                },
                                html: '<div class="level1-btn"><div class="btn-title">'+this.data04[14].name+'</div></div>',
                                scale: [1, 1],
                                hoverScale: 1.1,
                            },                           
                        ],
                    
                    }],
                   
                ],
            });
            const self = this
            const markersPlugin = viewer.getPlugin(MarkersPlugin);
            markersPlugin.addEventListener('select-marker', ({ marker }) => {
                self.link(marker); 
                if (marker.id === 'inf') {
                    this.openrightmenu();      
                }
                if (marker.id === 'photo') {
                    this.album();
                }                                                         
            });
                       

            
            viewer.addEventListener('ready', () => {
                viewer
  
                    .then(() => {
                        //markersPlugin.showMarkerTooltip('custom-tooltip');
                    });
            }, { once: true });

            //vr盒
            var panorama, viewer2, container;
            container = document.querySelector( '#container' );
            panorama = new PANOLENS.ImagePanorama( 'images/location4/4-3-7.jpg' );
            viewer2 = new PANOLENS.Viewer( {  container: container } );
            viewer2.enableEffect( PANOLENS.MODES.STEREO ); 
            viewer2.add(panorama);
        }
}
</script>


<style scoped>

</style>
